import Vue from 'vue';
import Vuex from 'vuex';
import commonApi from '@/api/commonApi';
import {DbscConstants} from "@/utils/constants";
import ebsApi from "@/api/ebsApi";
Vue.use(Vuex);

const state = {
    commonConfig: {
        copySnapshotLimit: 10,
        copySnapshotRegion: {},
        setdeleteTimeSnapshotLimit: 10,
        helpDocument: {
            云硬盘使用指南: '//docs.ksyun.com/documents/1046',
            快照使用指南: '//docs.ksyun.com/documents/2684',
            createSnapshot: '//docs.ksyun.com/documents/2684',
            recycleBin: '//docs.ksyun.com/documents/1055',
            upgradeCreateSnapshot: '//docs.ksyun.com/documents/5266',
            upgradeLinux: '//docs.ksyun.com/documents/39926',
            upgradeWindow: '//docs.ksyun.com/documents/39927',
            upgradeCareful: '//docs.ksyun.com/documents/39865',
            snapshotPrice: '//docs.ksyun.com/documents/37052',
            snapshotAgreement: '//docs.ksyun.com/documents/2737',
            snapshotBilling: '//sw.ksyun.com/pro/calc/#/oth/37393/doc',
            essdHelp: '//docs.ksyun.com/documents/2676'
        }
    },
    ebsPriceInfo: null,
    hasDbscPermission: false, // 当前 region 是否存在专属集群产品类型，如果没有并且之前也没有创建集群，则隐藏入口
    dbscCount: 0, // 专属集群数量，如果曾经创建过专属集群，则入口显示，若用户无专属集群权限，则无法创建新的集群
    dbscRegions: []
};
const getters = {
    commonConfig(state) {
        return state.commonConfig;
    }
};
const mutations = {
    setCommonConfig(state, value) {
        state.commonConfig = value;
    },
    setDbscPermission(state, value) {
        state.hasDbscPermission = value;
    },
    setDbscRegion(state, value) {
        state.dbscRegions = value;
    },
    setDbscCount(state, value) {
        state.dbscCount = value;
    },
    setEbsPriceInfo(state, value) {
        state.ebsPriceInfo = value;
    }
};
const actions = {
    async getQueryCommonConfig(context) {
        await commonApi
            .QueryCommonConfig()
            .then((res) => {
                if (res.status) {
                    context.commit('setCommonConfig', JSON.parse(res.data.Result));
                } else {
                    utils.showErrorTip(res);
                }
                actions.describeSnapshotCopyMax();
            })
            .catch((err) => {
                utils.showErrorTip(err);
                actions.describeSnapshotCopyMax();
            });
    },
    async describeSnapshotCopyMax() {
        await commonApi.DescribeSnapshotCopyMax().then((res) => {
            if (res.status && res.data && res.data.Max) {
                state.commonConfig.copySnapshotLimit = res.data.Max;
            }
        });
    },
    async initRegionList() {
        await commonApi.QuerySnapshotCopyRegionLimits().then((res) => {
            if (res.status) {
                let regionList = JSON.parse(res.data.Result);
                state.commonConfig.copySnapshotRegion = regionList;
            }
        });
    },
    checkHasDbscPermission(context) {
        if (!context.state.ebsPriceInfo.productTypeList) {
            return;
        }
        const regionKey = utils.getLocalStorageRegion();
        console.log('触发：', regionKey);
        const dbscProductTypes = context.state.ebsPriceInfo.productTypeList.filter(item => {
            return DbscConstants.DbscProductTypeIdList.includes(item.productTypeId);
        });
        let dbscRegions = [];
        // 是否包含当前 region 的专属集群权限
        let hasCurrentRegionDbscPermission = false;
        dbscProductTypes.forEach(item => {
            dbscRegions = dbscRegions.concat(item.regionList);
            console.log('item.regionList', item.regionList);
            if (Array.isArray(item.regionList)) {
                item.regionList.some(region => {
                    if (region.regionCode === regionKey) {
                        hasCurrentRegionDbscPermission = true;
                        return true;
                    }
                });
            }
        });
        console.log('hasCurrentRegionDbscPermission', hasCurrentRegionDbscPermission);
        // 没有权限，检查是否之前创建过专属集群
        if (!hasCurrentRegionDbscPermission) {
            let params = {
                MaxResults: 10,
                Marker: 1
            };
            ebsApi
                .describeDbscList(params)
                .then((res) => {
                    const dbscCount = res.data.TotalCount || 0;
                    context.commit('setDbscCount', dbscCount);
                });
        }
        context.commit('setDbscRegion', dbscRegions);
        context.commit('setDbscPermission', hasCurrentRegionDbscPermission);
    },
};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});
